const Images = {
    claim: require("./claim_requisition.png"),
    commission: require("./commission_requisition.png"),
    credit: require("./customer_credit.png"),
    equipment: require("./equipment_requisition.png"),
    manpower: require("./manpower_requisition.png"),
    purchase: require("./purchase_requisition.png"),
    replacement_leave: require("./replacement_leave_requisition.png"),
    training: require("./training_requisition.png"),
    travel: require("./travel_requisition.png"),
}

export {Images};